import React from 'react'
import { Stack, Table, TableBody, Grid, TableCell, TableContainer, TableHead, TableRow, Box, Button, Tooltip, Paper } from '@mui/material'
import moment from 'moment/moment'
import { useSelector } from 'react-redux'

const DispatchMiddSection7 = ({
  tableData,
  loginData,
  reportType,
  showSummaryReport,
  detailedFilter,
  selFromBranch,
  selDestCity,
  selBranch,
  toDate,
  fromDate,
  selVehicle,
  selPaymentTpe,
}) => {
  const companySettings = useSelector((state) => state?.common?.companySettings)
  const loginCountryId = companySettings[0]?.DefaultCurrencyID;
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const InsideRowContent = ({ item, index,fontVal }) => {
    return (
      <>
        <TableRow>
          {Object.keys(item).length == 23 ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={3}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.Station} {item.ToBranchName}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.TopayUnit.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.PaidUnit.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.OnAccountUnit.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.FocAndSelfUnit.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.DDDVUnit.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  backgroundColor: '#EEE',
                  textAlign: 'right',color:'#444',
                  borderRight: '1px solid #aeaeae',
                }}
              >
                {item.TotalUnits.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.TopayFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.PaidFreight.toFixed(2)}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE' }}>
                {item.OnAccountFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.FocAndSelfFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.DDDVFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  backgroundColor: '#EEE',
                  textAlign: 'right',color:'#444',
                  borderRight: '1px solid #aeaeae',
                }}
              >
                {item.TotalFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.TopayCodGstOth.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.PaidGstOth.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.OnActGstOth.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.FOCSelfGstOth.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  backgroundColor: '#EEE',
                  textAlign: 'right',color:'#444',
                  borderRight: '1px solid #aeaeae',
                }}
              >
                {item.DDDVGstOth.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.NetOther.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.Insurance.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.OtherCharge.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.TotalLRCount.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right',color:'#444' }}
              >
                {item.TotalNetAmount.toFixed(2)}
              </TableCell>
            </>
          ) : (
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'left' }}
              >
                {item.BusNumber} {item.SealNo}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'left',whiteSpace: 'pre',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '150px', }}
              >
                <Tooltip title={`${item.DriverConductorName} ${item.ContactNo}`} placement="top-start">
                  <span>
                    {item.DriverConductorName} <br />
                    {item.ContactNo}
                  </span>
                </Tooltip>
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',verticalAlign:'top',
                  textAlign: 'left',
                  whiteSpace: 'pre',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '150px',
                }}
              >
                <Tooltip title={`${item.Station} ${item.ToBranchName}`} placement="top-start">
                  <span>
                    {item.Station} <br />
                    {item.ToBranchName}
                  </span>
                </Tooltip>
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.TopayUnit}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.PaidUnit}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.OnAccountUnit}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.FocAndSelfUnit}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.DDDVUnit}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right', borderRight: '1px solid #aeaeae' }}
              >
                {item.TotalUnits}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.TopayFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.PaidFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.OnAccountFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.FocAndSelfFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.DDDVFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right', borderRight: '1px solid #aeaeae' }}
              >
                {item.TotalFreight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.TopayCodGstOth}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.PaidGstOth}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.OnActGstOth}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.FOCSelfGstOth}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right', borderRight: '1px solid #aeaeae' }}
              >
                {item.DDDVGstOth}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.NetOther}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.Insurance}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.OtherCharge}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.TotalLRCount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500',verticalAlign:'top', textAlign: 'right' }}
              >
                {item.TotalNetAmount}
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    )
  }

  return (
    <>
      <Stack sx={{ marginLeft: 2, marginRight: 2, height: 480, paddingTop: '10px' }}>
        <TableContainer className="scrollBlue" sx={{ '&::-webkit-scrollbar': { width: '6px', height: '6px' }, border: '1px solid #aeaeae','& .MuiTableCell-root': {
            fontSize: '14px !important'
        } }} component={Paper}>
          <Table  className="table1 table-Report" size="small" aria-label="a dense table">
            <TableHead style={{ position: 'sticky', top: '0' }}>
              <TableRow >
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'left',
                    color:'#444',
                    height: '36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={8}
                >
                  Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'left',
                    color:'#444',
                    height: '36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={8}
                >
                  Destination City: {selDestCity?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'left',
                    color:'#444',
                    height: '36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={9}
                >
                  Destination Branch: {selBranch?.name}
                </TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Vehicle No. <br /> Seal No.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Drvr Name <br /> Drvr No.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Disp. City. <br /> Disp. Br.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'pre',
                  }}
                  colSpan={1}
                >
                  {UseToPayAsCOD===1?'COD (#)':'Topay +\nCOD (#)'}
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Paid (#)
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  On- <br /> Act(#)
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  FOC+ <br /> Self (#)
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  DDDV (#)
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    borderRight: '1px solid #aeaeae',
                  }}
                  colSpan={1}
                >
                  NET (#)
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'pre',
                  }}
                  colSpan={1}
                >
                  {UseToPayAsCOD===1?'COD\nFrt.':'Topay + COD\nFrt.'}
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Paid <br />
                  Frt.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  On- Act <br />
                  Frt.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  FOC + COD <br />
                  Frt.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  DDDV <br /> Frt.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    borderRight: '1px solid #aeaeae',
                  }}
                  colSpan={1}
                >
                  NET <br /> Frt.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'pre',
                  }}
                  colSpan={1}
                >
                 {UseToPayAsCOD === 1? `COD\n${loginCountryId !== 2 ? 'GST+' : ''}OTH`: `Topay + COD\n${loginCountryId !== 2 ? 'GST+' : ''}OTH`}
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Paid <br />
                  {loginCountryId!==2&&`GST`}+OTH
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  On-Act <br /> {loginCountryId!==2&&`GST`}+OTH
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  FOC+Self <br />
                  {loginCountryId!==2&&`GST`}+OTH
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    borderRight: '1px solid #aeaeae',
                  }}
                  colSpan={1}
                >
                  DDDV <br />
                  {loginCountryId!==2&&`GST`}+OTH
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  NET <br />
                  {loginCountryId!==2&&`GST`}+OTH
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace:'pre'
                  }}
                  colSpan={1}
                >
                  {loginCountryId===2?'Insurance\nChrge.':'Val\nChrge.'}
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Oth. <br /> Chrge.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Net <br /> LR
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Net <br /> Amt.
                </TableCell>
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={25}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '12px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{ textAlign: 'center', fontSize: '12px', fontWeight: '500', marginLeft: '5px' }}
              >
                {tableData?.map((item, index) => (
                  <InsideRowContent item={item} index={index} key={index} fontVal={'12px'}/>
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
          <Table style={{display:"none"}} id="tables" className="table1 table-Report" size="small" aria-label="a dense table">
            <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={12}
                >
                  <h3 style={{ paddingLeft: '17px' }}>Report For: Dispatch Report -</h3>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'right' }}
                  colSpan={13}
                >
                  <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData.strCompanyName}</h3>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={25}></TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  From Dispatch Date
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                  }}
                  colSpan={3}
                >
                  To Dispatch Date
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                  }}
                  colSpan={3}
                >
                  dispatch By Branch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                  }}
                  colSpan={3}
                >
                  Destination City
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                  }}
                  colSpan={3}
                >
                  DestinationBranch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Vehicle Number
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Payment Type
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Report Type
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Report View
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                  }}
                  colSpan={3}
                >
                  Report Option
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{moment(fromDate).format('MM/DD/YYYY')}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                  <span>{moment(toDate).format('MM/DD/YYYY')}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                  <span>{selFromBranch?.name || loginData?.strBranchName}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                  <span>{selDestCity?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                  <span>{selBranch?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{selVehicle?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{selPaymentTpe?.name || 'All'}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{reportType?.Name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{showSummaryReport?.Name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                  <span>{detailedFilter?.Name} </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={25}></TableCell>
              </TableRow>
            </TableHead>
            <TableHead style={{ position: 'sticky', top: '0' }}>
              <TableRow >
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'left',
                    color:'#444',
                    height: '36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={8}
                >
                  Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'left',
                    color:'#444',
                    height: '36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={8}
                >
                  Destination City: {selDestCity?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'left',
                    color:'#444',
                    height: '36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={9}
                >
                  Destination Branch: {selBranch?.name}
                </TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Vehicle Number <br /> Seal Number
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Driver Name <br /> Drvr Number
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Dispatch City. <br /> Dispatch Branch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  {UseToPayAsCOD===1?'COD (#)':'Topay +\nCOD (#)'}
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    verticalAlign:'top'
                  }}
                  colSpan={1}
                >
                  Paid (#)
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  On-Account<br />(#)
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  FOC+ <br /> Self (#)
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    verticalAlign:'top'
                  }}
                  colSpan={1}
                >
                  DDDV (#)
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    borderRight: '1px solid #aeaeae',
                    verticalAlign:'top'
                  }}
                  colSpan={1}
                >
                  NET (#)
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  {UseToPayAsCOD===1?'COD\nFreight':'Topay + COD\nFreight'}
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Paid <br />
                  Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  On-Account <br />
                  Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  FOC + COD <br />
                  Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  DDDV <br /> Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    borderRight: '1px solid #aeaeae',
                  }}
                  colSpan={1}
                >
                  NET <br /> Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  {UseToPayAsCOD === 1? `COD\n${loginCountryId !== 2 ? 'GST+' : ''}OTHER`: `Topay + COD\n${loginCountryId !== 2 ? 'GST+' : ''}OTHER`}
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  Paid <br />
                  {loginCountryId!==2&&`GST`}+OTHER
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  On-Account<br /> {loginCountryId!==2&&`GST`}+OTHER
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  FOC+Self <br />
                  {loginCountryId!==2&&`GST`}+OTHER
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    borderRight: '1px solid #aeaeae',
                  }}
                  colSpan={1}
                >
                  DDDV <br />
                  {loginCountryId!==2&&`GST`}+OTHER
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                  }}
                  colSpan={1}
                >
                  NET <br />
                  {loginCountryId!==2&&`GST`}+OTHER
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  {loginCountryId===2?'Insurance\nCharge':'Val\nCharge'}
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Other <br /> Charge
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Net <br /> LR
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color:'#444',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                  }}
                  colSpan={1}
                >
                  Net <br /> Amount
                </TableCell>
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={25}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '20px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{ textAlign: 'center', fontSize: '20px', fontWeight: '500', marginLeft: '5px' }}
              >
                {tableData?.map((item, index) => (
                  <InsideRowContent item={item} index={index} key={index} fontVal={'20px'}/>
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
        </TableContainer>
      </Stack>
    </>
  )
}

export default DispatchMiddSection7
